import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { ToolModeToggle } from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { HexDecode, HexEncode } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function Hex() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'Hex Encoder/Decoder', Iconpath: "/hash.svg" };
    const [mode, setMode] = useState("encode");


    


    useEffect(() => {
        setText("")
        setresult("")
    }, [mode]);

    



    const handleChange = async (e) => {
        const value = e.target.value;
        setText(value);
    };

    const getResult = async (value) => {
        if (mode === "encode") {
            try {
                const response = await HexEncode({ input: value });
                setresult(response.data.hex);
            }
            catch(error) {
                console.error("Error in encoding:", error);
                setresult(error.response?.data?.message || "Error in encoding.");
            }
        } else {
            try {
                const response = await HexDecode({ input: value });
                setresult(response.data.decoded);
            }
            catch (error) {
                console.error("Error in decoding:", error);
                setresult(error.response?.data?.message || "Error in decoding.");
            }   
        }
    };

    const handleImport = (fileContent) => {
        setText(fileContent);
    }
    const Execute = async () => {
         if(text.trim() === "") {
            setresult("");
            return;
        }
        getResult(text);
    }

    const pasteExample = () => {
        let exampleValue = "";

        if (mode === "encode") {
            exampleValue = "Hello World";
        } else {
            exampleValue = "68656c6c6f20576f726c64";
        }

        setText(exampleValue);
    };

    return (
        <>
            <Col>
                <ToolHeader title="Hex Encoder/Decoder" description="Encode text into hexadecimal or decode hex strings back to readable format for easy data conversion and debugging" toolFav={toolFav} />

                <ToolModeToggle
                    options={[
                        { label: "Encode", value: "encode", className: "encode" },
                        { label: "Decode", value: "decode", className: "decode" }
                    ]}
                    activeValue={mode}
                    onChange={setMode}
                />
                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder={mode === "encode" ? "Paste text to encode.." : "Paste text to decode.."}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    executeLabel={mode === "encode" ? "Encode" : "Decode"}
                                    showExecute={true}
                                    onExecute={Execute}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Formatted Text"
                            value={result ?? ""}
                            placeholder="Formatted text will appear here..."
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={`${mode === "encode" ? "hex-encode" : "hex-decode"}.txt`}
                                    mimeType="text/plain;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default Hex;
